module.exports = __webpack_public_path__ + "static/img/yycj_06.6024dce.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/yycj_06.png
// module id = ajry
// module chunks = 2